export enum PageTitle {
  Dashboard = 'insights',
  Campaigns = 'campaign',
  AppExperiences = 'app-experiences',
  Promotions = 'promotions',
  Forms = 'forms',
  Surveys = 'surveys',
  Referral = 'referral',
  Games = 'games',
  NudgeTour = 'nudge-tour',
  Quiz = 'quiz',
  Sales = 'sales',
  SettingContactFields = 'settingContactFields',
  CustomerDashboard = 'customer-dashboard',
  SettingWidget = 'settingWidget',
  Backoffice = 'filter-all',
  Templates = 'templates',
  TemplateSettings = 'template-settings',
  Editor = 'editor',
}
